import { QueryClientConfig } from "@tanstack/react-query";

export const QUERY_CONFIG: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 10 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 5 minutes
      refetchOnMount: false,
    },
  },
};
